module.exports = __webpack_public_path__ + "static/img/select-img9.6289ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img9.png
// module id = xX6B
// module chunks = 1